import { render, staticRenderFns } from "./InvoiceRecords.vue?vue&type=template&id=2ace22af"
import script from "./InvoiceRecords.vue?vue&type=script&lang=js"
export * from "./InvoiceRecords.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecords.vue?vue&type=style&index=0&id=2ace22af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports